export const FORM_COLOR_ELEMENTS = [
  {
    id: 'text',
    label: 'Text',
    hint: 'Title, labels and small print',
    slots: [{ key: 'text', label: 'Text', site: '#1F2937' }]
  },
  {
    id: 'fields',
    label: 'Answer boxes',
    hint: 'Where visitors type',
    slots: [
      { key: 'field', label: 'Fill' },
      { key: 'field_text', label: 'Text', site: '#1F2937' }
    ]
  },
  {
    id: 'button',
    label: 'Button',
    hint: 'The send button',
    slots: [
      { key: 'button', label: 'Fill' },
      { key: 'button_text', label: 'Text' }
    ]
  },
  {
    id: 'background',
    label: 'Background',
    hint: 'Behind the whole form',
    slots: [{ key: 'background', label: 'Fill', site: '#FFFFFF' }]
  }
]

export const CHAT_COLOR_ELEMENTS = [
  {
    id: 'header',
    label: 'Header',
    hint: 'The bar across the top',
    slots: [
      { key: 'header', label: 'Fill' },
      { key: 'header_text', label: 'Text' }
    ]
  },
  {
    id: 'background',
    label: 'Background',
    hint: 'Behind the conversation',
    slots: [{ key: 'background', label: 'Fill' }]
  },
  {
    id: 'agent',
    label: 'Agent messages',
    hint: 'Its bubbles, cards and the reply box',
    slots: [
      { key: 'agent', label: 'Fill' },
      { key: 'agent_text', label: 'Text' }
    ]
  },
  {
    id: 'visitor',
    label: 'Visitor messages',
    hint: 'What the visitor sends',
    slots: [
      { key: 'visitor', label: 'Fill' },
      { key: 'visitor_text', label: 'Text' }
    ]
  },
  {
    id: 'accent',
    label: 'Highlight',
    hint: 'The logo mark and hover tints',
    slots: [{ key: 'accent', label: 'Fill' }]
  },
  {
    id: 'button',
    label: 'Chat button',
    hint: 'The bubble, Send and picked answers',
    slots: [
      { key: 'button', label: 'Fill' },
      { key: 'button_text', label: 'Text' }
    ]
  }
]

export const PRESET_COLORS = [
  '#1B2420',
  '#111111',
  '#FFFFFF',
  '#FDFBF6',
  '#FDFF74',
  '#E2A33C',
  '#D9542B',
  '#C2453A',
  '#DB2777',
  '#7C3AED',
  '#1D4ED8',
  '#2F7D5B'
]

export const normalizeHex = value => {
  let digits = String(value ?? '')
    .trim()
    .replace(/^#/, '')
  if (digits.length === 3) digits = [...digits].map(digit => digit + digit).join('')
  if (digits.length === 8) digits = digits.slice(0, 6)
  return /^[0-9a-f]{6}$/i.test(digits) ? `#${digits.toUpperCase()}` : null
}

export const luminance = hex => {
  const number = parseInt(hex.slice(1), 16)
  const [red, green, blue] = [(number >> 16) & 255, (number >> 8) & 255, number & 255].map(part => {
    const value = part / 255
    return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4
  })
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue
}

export const contrast = (first, second) => {
  const [light, dark] = [luminance(first), luminance(second)].sort((a, b) => b - a)
  return (light + 0.05) / (dark + 0.05)
}

export const shownColor = (colors, slot) => colors[slot.key] || slot.site || '#FFFFFF'

export const isHardToRead = (element, colors) => {
  if (element.slots.length < 2) return false
  const [fill, text] = element.slots.map(slot => shownColor(colors, slot))
  return contrast(fill, text) < 3
}
